
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tv/basic/vod/[client]/[id]",
      function () {
        return require("private-next-pages/tv/basic/vod/[client]/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tv/basic/vod/[client]/[id]"])
      });
    }
  